module.exports = __webpack_public_path__ + "static/vocus-6a06fcc3d14b0735ddedc451409294f3.svg";